<template>
  <div id="task-running" style="height: 35vh"></div>
</template>

<script>
import * as echarts from "echarts/core";
import { TooltipComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([TooltipComponent, PieChart, CanvasRenderer, LabelLayout]);

export default {

  props: {
    detail: {
      type: Object,
    }
  },

  computed: {
    typeAnalysis() {
      return Array.isArray(this.detail.typeAnalysis) ? this.detail.typeAnalysis : []
    }
  },

  watch: {
    typeAnalysis: {
      handler() {
        this.setChart()
      },
      deep: true,
    }
  },

  mounted() {
    var chartDom = document.getElementById("task-running");
    this.chart = echarts.init(chartDom);
    this.setChart();
  },

  beforeDestroy() {
    this.chart?.dispose();
  },

  methods: {
    setChart() {

      if (this.typeAnalysis.length === 0) return;

      var option = {
        color: ["#4ECB73", "#FBD437", "#FFA700", "#3AA1FF"],
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "65%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter: ["{title|{b}}", "{percentage|{d}%}"].join("\n"),
              rich: {
                title: {
                  lineHeight: 24,
                },
                percentage: {
                  fontSize: 16,
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              show: true,
            },
            data: this.typeAnalysis.map(item => {
              return {
                name: item.key,
                value: item.value,
              }
            })
          },
        ],
      };

      option && this.chart.setOption(option);
    }
  }
};
</script>